import cx from 'classnames';
import PropTypes from 'prop-types';

import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { Information, INFORMATION_SIZE } from 'src/components/Information';
import { TruncatedTypography } from 'src/components/TruncatedTypography';

import { useStyles } from './useStyles';

export const PanelTitle = ({ className, classes, title, hint, optional, modified, titleBold }) => {
  const styles = useStyles({ classes });

  return (
    <div className={cx(styles.root, className, { [styles.titleBold]: titleBold })}>
      {title && (
        <TruncatedTypography
          className={styles.title}
          variant={TYPOGRAPHY_VARIANT.medium14}
        >
          {title}
        </TruncatedTypography>
      )}

      {optional && (
        <CustomTypography
          className={styles.extra}
          variant={TYPOGRAPHY_VARIANT.regular12}
        >
          (optional)
        </CustomTypography>
      )}
      {modified && (
        <CustomTypography
          className={styles.extra}
          variant={TYPOGRAPHY_VARIANT.regular12}
        >
          (modified)
        </CustomTypography>
      )}

      {hint && (
        <Information
          className={styles.information}
          size={INFORMATION_SIZE.small}
          content={hint}
        />
      )}
    </div>
  );
};

PanelTitle.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.shape({}),
  title: PropTypes.string,
  hint: PropTypes.oneOfType([PropTypes.string, PropTypes.shape({})]),
  optional: PropTypes.bool,
  modified: PropTypes.bool,
  titleBold: PropTypes.bool,
};
PanelTitle.defaultProps = {
  className: '',
  classes: null,
  title: '',
  hint: '',
  optional: false,
  modified: false,
  titleBold: false,
};
